<!-- Registry / Platefolio panel — "PlateX 33.3" prototype, ported to Angular.
     Conditional copy comes from `config` (see component); the layout matches the
     prototype's two-column registry panel. -->
<section class="registry" *ngIf="config as r">
  <div class="wrap">
    <div class="registry-panel">
      <!-- LEFT: the ask -->
      <div class="registry-left">
        <div class="eyebrow">{{ r.eyebrow }}</div>
        <h2>{{ r.heading }}</h2>
        <p>{{ r.body }}</p>

        <div class="registry-cta-row">
          <button
            type="button"
            *ngFor="let c of r.ctas"
            [class.btn-claim]="c.type === 'primary'"
            [class.btn-ghost]="c.type === 'ghost'"
            (click)="runCta(c)"
          >
            {{ c.label }}
          </button>
        </div>
      </div>

      <!-- RIGHT: ownership tick list (Platefolio) OR feature list -->
      <div class="registry-features">
        <!-- Platefolio "Own this registration?" — ticked ownership list. -->
        <ng-container *ngIf="r.ownerList?.length">
          <div class="reg-list-label" *ngIf="r.ownerIntro">
            {{ r.ownerIntro }}
          </div>
          <div class="reg-own" *ngFor="let t of r.ownerList">
            <span class="reg-own-tick">
              <svg
                class="tick"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.4"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
            </span>
            <span>{{ t }}</span>
          </div>
        </ng-container>

        <!-- Watchlist / registry variants — feature list. -->
        <ng-container *ngIf="!r.ownerList?.length && r.features?.length">
          <div class="reg-feature" *ngFor="let f of r.features">
            <div class="rf-ico">
              <mat-icon>{{ f.icon }}</mat-icon>
            </div>
            <div>
              <div class="rf-title">{{ f.title }}</div>
              <div class="rf-desc">{{ f.desc }}</div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</section>
